import styled from 'styled-components'

export const Main = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 35px 0;

  @media (min-width: 1300px) {
    height: 100vh;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90vw;
  height: 800px;
  /* background: rgba(255, 255, 255, 0.75);
  box-shadow: 0 8px 32px 0 rgba(149, 114, 39, 0.37);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18); */
  position: relative;

  @media (min-width: 1300px) {
    flex-direction: initial;
    justify-content: center;
    height: 90vh;
  }

  img {
    width: 80vw;
    border-radius: 10px;

    @media (min-width: 500px) {
      max-height: 60vh;
      width: auto;
      max-width: 400px;
    }

    @media (min-width: 1300px) {
      margin: -100px 100px 50px 0;
      max-width: 500px;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h2 {
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 7vw;

    @media (min-width: 500px) {
      font-size: 36px;
    }

    @media (min-width: 1300px) {
      font-size: 4vw;
      line-height: 150px;
    }
  }

  h3 {
    line-height: 26px;
    font-size: 16px;
    text-align: justify;

    @media (min-width: 1300px) {
      font-size: 2vw;
      line-height: 6.5vh;
    }
  }
`

export const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;

  button {
    width: 80vw;
    height: auto;
    margin: 20px;
    padding: 18px;
    color: #ffffff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    border-radius: 16px;
    font-weight: bold;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      -45deg,
      #2196f3,
      #0d47a1,
      #0d47a1 50%,
      #2196f3
    );
    &:hover {
      background-image: linear-gradient(
        90deg,
        #0d47a1,
        #2196f3,
        #2196f3 50%,
        #0d47a1
      );
      background-position: -100%;
    }
  }
`

export const Voltar = styled.div`
  display: flex;
  align-items: center;
  color: #0d47a1;
  cursor: pointer;
  font-size: 18px;
  margin-bottom: 0vh;
  font-weight: bold;
`
